var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"860d3c6848ed674f7a48f080154029537c5d3ff1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["buscounchollo-prod@sentry"]={id:"860d3c6848ed674f7a48f080154029537c5d3ff1"};
      